module.exports = __webpack_public_path__ + "media/images/file-arrow-up-584dfca3.svg";